export default (props => {
  const isAriaProp = key => key.startsWith('aria-');
  const componenyPropKeys = Object.keys(props);
  const ariaProps = componenyPropKeys.reduce((newData, key) => {
    if (isAriaProp(key)) {
      const ariaValue = props[key];
      // type hack: TS can't infer the type for values of newData, it thinks they're undefined
      // cast this to undefined to make TS happy
      newData[key] = ariaValue;
    }
    return newData;
  }, {});
  return ariaProps;
});
//# sourceMappingURL=getAriaProps.js.map